import React from 'react';
import _ from 'lodash';
import autoBind from 'react-autobind';

import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';

import Field from '@common/components/validation/field.validation';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import DateFormat from '@common/components/formats/date.format';
import DateInput from '@common/components/dateInput/dateInput.component';

import { OverlayTrigger, Tooltip as TooltipBootstrap, FormGroup } from 'react-bootstrap';

import FocusHelper from '@common/helpers/focus.helper';

import DateHelper from '@common/helpers/date.helper';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  validate(value) {
    const { DataFutura } = this.props;

    const dataHoje = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

    if(!value?.getFullYear)
      return;

    const dataValor = new Date(value.getFullYear(), value.getMonth(), value.getDate());

    if (dataValor.getFullYear() < 1753) return 'O ano deve ser maior que 1752.';
    if (!DataFutura && dataValor > dataHoje) return 'A data não deve ser maior que a data atual.';
  }

  async validateOnBlur(name, label, value) {
    if (value && value != '__/__/____') {
      if (value.includes('_')) {
        var inputDate = document.querySelector(`input[name=${name}]`);
        const result = await _alert.warningPromise(`O valor do campo ${label} é inválido.`, 'Data inválida.');
        if (result) {
          inputDate.focus();
        }
      }
    }
  }

  componentDidMount() {
    this.setFocus();
  }

  setFocus() {
    const { name, setFocus } = this.props;
    if (setFocus) FocusHelper.focus(name);
  }

  renderComponent() {
    const { props, validate } = this;
    const { Label, Tooltip, Obrigatorio, Desabilitado, name, validateOnBlur, PlacementTooltip } = props;
    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChangeAsync, onBlur }) => {
          return (
            <LabeledInput {...props}>
              <OverlayTrigger
                key={`top-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  <TooltipBootstrap id={`tooltip-${name}`}>
                    <div className={'fontTooltip'}>{Tooltip || Label}</div>
                  </TooltipBootstrap>
                }
              >
                <div>
                  <DatePicker
                    ref={(ref) => (this.datePicker = ref)}
                    className={`form-control ${hasError ? 'span-input-invalid' : ''}`}
                    dateInput={DateInput}
                    value={value ? DateHelper.getOnlyDateByText(value) : null}
                    name={name}
                    format={'dd/MM/yyyy'}
                    validityStyles={false}
                    disabled={Desabilitado}
                    required={Obrigatorio}
                    onChange={onChangeAsync}
                    onBlur={(event) => {
                      this.datePicker.setState({ show: false });
                      validateOnBlur && this.validateOnBlur(name, Label, event.target.value);
                      onBlur();
                    }}
                    formatPlaceholder={{ year: '____', month: '__', day: '__' }}
                  />
                </div>
              </OverlayTrigger>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control" readOnly>
                  <DateFormat value={field.value} onlyDate={!this.props.ExibirHoras} />
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>
                  <DateFormat value={field.value} onlyDate={true} />
                </label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
